const baseMdcBlockGroup = require('./_BaseMdcBlockGroup');
const logging = require('@sstdev/lib_logging');
const {
    moduleRegistration: { registerHNodeType }
} = require('@sstdev/lib_metadata-config');
/**
 * Base class for fully converted Block Groups
 * If some of the blocks definitions are still in the old format,
 * don't use this. If you do, you will want to override the constructor to set your own types:
 * ```
 *   constructor(hNodeTypeGroup, categorySpec, color, subset = '') {
 *       super(hNodeTypeGroup, categorySpec, color, subset);
 *       super.types = types;
 *   }
 * ```
 */
class DelegatingMdcBlockGroup extends baseMdcBlockGroup {
    constructor(hNodeTypeGroup, categorySpec, color, subset = '') {
        super(hNodeTypeGroup, categorySpec, color, subset);
        Object.entries(this.types).forEach(([hNodeType, module]) => {
            registerHNodeType(hNodeTypeGroup, hNodeType, module);
        });
    }
    types = {};

    /**
     * allow blocks to define specific fields to be shown in MDC
     * @param {*} color
     * @param {*} blocklyBlock
     * @param {*} hNodeType
     * @param {*} mdcBlock
     * @param {*} topInput
     */
    addToBlocksCustom(color, blocklyBlock, hNodeType, mdcBlock, topInput) {
        if (!this.types[hNodeType]) {
            logging.error(
                `'${hNodeType}' is missing an hNodeType definition in the ${mdcBlock.hNodeTypeGroup} hNodeTypeGroup in lib_metadata-transforms.`
            );
            return;
        }
        this.types[hNodeType]?.addBlockSpecificFields?.(color, blocklyBlock, mdcBlock, topInput);
    }

    /**
     * allows blocks to define how the specific fields are translated into a JSON object
     * @param {*} code
     * @param {*} blocklyBlock
     * @param {*} hNodeType
     * @returns {string} string representation of JSON object
     */
    addCodeGeneratorCustom(code, blocklyBlock, hNodeType) {
        //block specific things (mutates `code`)
        this.types[hNodeType]?.convertCustomFieldsToCode?.(code, blocklyBlock);
        return JSON.stringify(code);
    }

    /**
     * allows blocks to configure specific standard child blocks (e.g. standard filters)
     * @param {*} section
     */
    customizeToolbox(section) {
        section.contents.forEach(block => {
            // mutate the `block` as shown in the toolbox
            // but only if something is actually implemented for that block type (hNodeType)
            // block.type is something like 'searchElement_ValueSearch', so we only want the 2nd part
            const [, type] = block.type.split('_');
            this.types[type]?.customizeToolbox?.(block);
        });
    }
}

module.exports = DelegatingMdcBlockGroup;
